import { Input, InputProps, styled } from '@mui/material'
import { CommonFieldProps } from '.'

const StyledInput = styled((props: InputProps) => <Input {...props} />)(() => ({
  display: 'none'
}))

type HiddenFieldProps = Pick<CommonFieldProps, 'name'>

export const HiddenField = ({ name }: HiddenFieldProps) => {
  return <StyledInput type="hidden" name={name} />
}
